import { createContext } from 'react';

const SchoolItemContext = createContext();

export default SchoolItemContext;
